module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_6005.69af4d69.png";